"use strict";

class StationSettingsApplicationsMarketplaceCtrl {
    constructor($rootScope, $http, $mdToast, $mdDialog, $scope, $state) {
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$http = $http;
        this.$mdToast = $mdToast;
        this.$mdDialog = $mdDialog;
        this.$state = $state;

        this.installed = [];
        this.installerNames = {};

        this.fetch();
    }

    fetch() {
        this.$http.get('/marketplace').then((response) => {
            this.applications = response.data;
            for(let index = 0; index < response.data.length; index++){
                this.installerNames[index] = JSON.parse(response.data[index].installer).system_name;
            }
        });
        this.$http.get('/applications').then((response) => {
            for(let index = 0; index < response.data.length; index++){
                this.installed[index] = response.data[index].system_name;
            }
        });
    }

    install(id) {
        this.$mdDialog.show({
            controller: 'ApplicationInstallerDialogCtrl',
            templateUrl: "applicationInstallerDialog.ngTemplate",
            parent: angular.element(document.querySelector('#popupContainer')),
            clickOutsideToClose: true,
            locals: {
                applicationId: id,
            }
        });
    }
}

StationSettingsApplicationsMarketplaceCtrl.$inject = [
    '$rootScope',
    '$http',
    '$mdToast',
    '$mdDialog',
    '$scope',
    '$state'
];

module.exports = StationSettingsApplicationsMarketplaceCtrl;